import { OptionI } from './optionBuilders'

export const MISCELLANEOUS = 'Miscellaneous'

export const sortOptions = <T>(options: OptionI<T>[]): OptionI<T>[] => {
  return [...options].sort((a, b) => a.label.localeCompare(b.label))
}

export const sortOptionsWithLabelLast = <T>(
  options: OptionI<T>[],
  label: string
): OptionI<T>[] => {
  return [...options].sort((a, b) => {
    if (a.label === label) return 1
    if (b.label === label) return -1
    return 0
  })
}

export const getDefaultOption = <T>(
  option: OptionI<T> | OptionI<T>[]
): OptionI<T> | OptionI<T>[] | null => {
  if (Array.isArray(option)) {
    return option?.length ? option : null
  } else {
    return option || null
  }
}

export const mapOptions = <T>(arr: T[]): OptionI<T>[] =>
  arr.map((optionValue) => ({
    label: optionValue as string,
    value: optionValue,
  }))

export const getOptionsArray = <T>(options: OptionI<T>[] | OptionI<T>) =>
  Array.isArray(options) ? options : [options]
